import { render, staticRenderFns } from "./IngredientStockAlertView.vue?vue&type=template&id=997e4c8e&scoped=true"
import script from "./IngredientStockAlertView.vue?vue&type=script&lang=js"
export * from "./IngredientStockAlertView.vue?vue&type=script&lang=js"
import style0 from "./IngredientStockAlertView.vue?vue&type=style&index=0&id=997e4c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997e4c8e",
  null
  
)

export default component.exports